module.exports = __webpack_public_path__ + "img/16.97f17a37.jpg";